<div class="w-full" data-testid="feature-update-feedback-container">
  @if (showModal()) {
    <div
      class="fixed inset-0 bg-brand-dimBlack/50 flex items-center justify-center p-4 z-[70]"
      data-testid="feature-update-modal-overlay"
    >
      <div
        class="w-full max-w-2xl max-h-screen overflow-y-auto hide-scrollbar"
        data-testid="feature-update-modal-wrapper"
      >
        <app-first-time-action-feedback-modal
          [title]="title()"
          [questions]="questions()"
          [ratingQuestion]="ratingQuestionText()"
          [yesNoQuestion]="yesNoQuestionText()"
          [textQuestion]="textQuestionText()"
          [submitLabel]="UI_CONTENT.submitLabel"
          (submitted)="onFeedbackSubmitted($event)"
          (cancelled)="onDismissed()"
          [attr.data-testid]="'feature-update-modal-' + (isSubmitting() ? 'submitting' : 'ready')"
        />
      </div>
    </div>
  }

  @if (errorText()) {
    <div
      class="fixed inset-0 bg-brand-dimBlack/50 flex items-center justify-center p-4 z-[70]"
      data-testid="feature-update-error-overlay"
    >
      <div
        class="bg-brand-white rounded-2xl p-6 max-w-md shadow-lg"
        data-testid="feature-update-error-message"
      >
        <h2 class="text-lg font-bold text-brand-black mb-2">{{ UI_CONTENT.errorTitle }}</h2>
        <p class="text-brand-gray text-sm mb-6">{{ errorText() }}</p>
        <div class="flex gap-3">
          <button
            type="button"
            (click)="onModalClosed()"
            class="flex-1 px-4 py-2 text-sm font-medium text-brand-slateGrey bg-brand-muteShadow hover:bg-brand-muteShadow/80 rounded-xl transition-colors"
            data-testid="feature-update-error-close-btn"
          >
            {{ UI_CONTENT.closeLabel }}
          </button>
          <button
            type="button"
            (click)="onRetry()"
            class="flex-1 px-4 py-2 text-sm font-medium text-brand-white bg-brand-primary hover:bg-brand-strongRed rounded-xl transition-colors"
            data-testid="feature-update-error-retry-btn"
          >
            {{ UI_CONTENT.retryLabel }}
          </button>
        </div>
      </div>
    </div>
  }

  @if (showSuccessModal()) {
    <app-feedback-success-modal
      [title]="UI_CONTENT.successTitle"
      [message]="UI_CONTENT.successMessage"
      [confirmLabel]="UI_CONTENT.successConfirmLabel"
      [overlayTestId]="'feature-update-success-overlay'"
      [modalTestId]="'feature-update-success-modal'"
      [confirmTestId]="'feature-update-success-ok'"
      (confirmed)="onCloseSuccessModal()"
    />
  }
</div>
